import React, { useEffect } from 'react';
import './acservice.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import AcDesc1 from '../images/acdesc1.jpg';
import AcDesc2 from '../images/acdesc2.jpg';
import AcDesc3 from '../images/acdesc3.jpg';
import ACgal1 from '../images/acgal1.jpg'; // Adjust path as necessary 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillWave, faWrench, faTachometerAlt, faHome } from '@fortawesome/free-solid-svg-icons';




export default function AcService() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <div>
    <div><Navbar /></div>
    <div>
      <section id="hero" style={{ backgroundImage: `url(${ACgal1})` }}>
        <div className="hero-content">
          <h1>AC SERVICE CENTER</h1>
          <p>Your Trusted Solution for All Appliance Repairs</p>
          <a href="tel:+919176849803" className="hero-btn">Book Service?</a>
        </div>
      </section>

      <section id="About">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
              <h2>About</h2>
              <p>Welcome to Sri Hari Home Care! With over six years of dedicated experience, we are proud to be your trusted partner for air conditioner repairs. We understand how vital a properly functioning AC is to your comfort, especially during those Summer days. Our expert team is here to ensure your AC performs at its best, keeping your home cool and comfortable.

At Sri Hari Home Care, transparency is at the heart of our service. Trust is the foundation of our relationship with you, and that’s why we keep you informed at every step of the repair process. Our skilled technicians deliver high-quality service, explaining the costs and methods involved to restore your AC efficiently.

Customer satisfaction is our top priority. We are committed to providing timely, dependable service, so you can rely on us whenever your AC needs attention. From minor issues to major repairs, our team is ready to help you get your air conditioner back to peak performance.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={AcDesc1} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>High Quality Service</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>At Sri Hari Home Care, we specialize in high-quality air conditioner repair and maintenance to keep your home cool and comfortable. Our skilled technicians are experienced in servicing all brands and types of air conditioning units, including split, window, and portable models. We use only genuine parts for repairs, ensuring optimal performance and energy efficiency. With over six years of trusted service, Sri Hari Home Care is committed to transparency in pricing and process, giving you peace of mind with every service. Our goal is to deliver quick, reliable solutions that you can count on, helping you stay comfortable without interruption.</p>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={AcDesc2} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Affordable Service</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Sri Hari Home Care provides affordable air conditioner repair and maintenance services, ensuring your cooling system operates efficiently. Our team of experienced technicians is equipped to handle all types of air conditioning units, including split, window, and portable models from various brands. With over six years of trusted service, we pride ourselves on transparency and integrity, offering clear pricing and reliable solutions. Sri Hari Home Care delivers timely and effective repairs using genuine spare parts to enhance your AC’s performance and longevity. Count on us for budget-friendly service that keeps your home comfortable throughout the year.</p>
    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={AcDesc3} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Best Service Center</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Sri Hari Home Care is your best choice for expert air conditioner repair and maintenance services, ensuring your home stays cool and comfortable all year round. Our highly skilled technicians specialize in servicing all types of AC units—including split, window, and portable models—across a wide range of brands. With over six years of trusted experience, we stand out for our commitment to transparency, offering competitive pricing and dependable solutions for all your cooling needs. We utilize genuine parts and cutting-edge tools to provide efficient repairs that enhance your AC’s performance and energy efficiency. Choose Sri Hari Home Care for fast, reliable service that keeps your air conditioner operating at its best, especially during the Summer months.</p>
    </div>
  </div>
</section>


<section class="what-we-do">
  <div class="container">
    <h2>What We Do</h2>
    <p>At <strong>Sri Hari Home Care</strong>, we have been serving Chennai with pride for over <strong>6+ years</strong>, providing reliable and professional appliance repair services for washing machines, refrigerators, and air conditioners.</p>
    
    <div class="service-process">
      <div class="step">
        <h3>1. Easy Access</h3>
        <p>Our website is equipped with Google Ads, making it easy for customers to find us when they search for appliance repair services. With a quick phone call from our website, customers are instantly connected to our support team.</p>
      </div>
      <div class="step">
        <h3>2. Efficient Complaint Registration</h3>
        <p>Our customer support team registers the complaint and forwards it to a trained technician. Our team is committed to fast response times and customer satisfaction.</p>
      </div>
      <div class="step">
        <h3>3. Technician Appointment</h3>
        <p>Our technician contacts the customer to set up an appointment. We respect your time, arriving punctually and working efficiently.</p>
      </div>
      <div class="step">
        <h3>4. Quick and Reliable Repair</h3>
        <p>Upon arrival, our technician assesses the issue and repairs it within <strong>3-4 hours</strong>. If any spare parts need replacement, the technician shows the customer the faulty part and explains the need for a new one.</p>
      </div>
      <div class="step">
        <h3>5. Transparent and Fair Pricing</h3>
        <p>We charge a service fee of <strong>₹400</strong>. If any spare parts are replaced, they are charged at market rates, ensuring quality and transparency. All parts are opened in front of the customer for full confidence.</p>
      </div>
    </div>
  </div>
</section>

<section class="ac-issues-section">
  <h2 class="section-heading">Issues in AC</h2>
  <div class="issues-container">
    
    <div class="issue-card">
      <i class="fas fa-tint icon"></i>
      <h3 class="issue-title">Water Leakage</h3>   
      <p class="issue-description">Water leakage in an AC could be due to a clogged drain line or a frozen evaporator coil. Quick attention is necessary to prevent water damage.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-cogs icon"></i>
      <h3 class="issue-title">Not Cooling</h3>
      <p class="issue-description">If the AC isn’t cooling properly, it may be due to low refrigerant or a compressor failure. Immediate repair is needed to restore cooling efficiency.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-exclamation-triangle icon"></i>
      <h3 class="issue-title">Noisy Operation</h3>
      <p class="issue-description">Excessive noise may indicate issues with the fan or motor. This can lead to further damage if not repaired promptly.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-plug icon"></i>
      <h3 class="issue-title">Power Issues</h3>
      <p class="issue-description">Power problems may be linked to the AC's control board or electrical connections. A certified technician can diagnose and fix the issue.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-thermometer-half icon"></i>
      <h3 class="issue-title">Temperature Fluctuations</h3>
      <p class="issue-description">Inconsistent temperatures may be due to a faulty thermostat or low refrigerant levels. Professional servicing can help resolve this issue.</p>
    </div>

  </div>
</section>




      <section id="tech-spec" class="tech-special-section">
  <h2 class="section-title">Our Tech-Special</h2>
  <div class="tech-features-container">
      
      <div class="tech-feature">
          <i class="fas fa-cogs icon"></i>
          <h3>Work Performance</h3>
          <p>Our team delivers top-notch performance on every job, ensuring your appliances are handled with expert care and precision.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-clock icon"></i>
          <h3>Punctuality</h3>
          <p>We respect your time. Our technicians arrive on schedule and complete tasks within the estimated time frame.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-bolt icon"></i>
          <h3>Speed of Work</h3>
          <p>Efficiency is key. We complete repairs and maintenance swiftly without compromising on quality.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-headset icon"></i>
          <h3>Quick Response</h3>
          <p>Our customer service team is quick to respond to inquiries and schedule appointments with minimal delay.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-user-friends icon"></i>
          <h3>Friendly Technicians</h3>
          <p>Our technicians are not only skilled but also friendly and courteous, ensuring a positive service experience.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-broom icon"></i>
          <h3>Neat & Clean Work</h3>
          <p>We leave no mess behind. Our technicians ensure that your space is as clean as it was before the service.</p>
      </div>

  </div>
</section>


<section class="testimonials">
  <h2 class="section-title" id="testihead">Customer Testimonials</h2>
  <div class="testimonial-container">
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Our AC service was excellent! Very reliable and on time."</p>
          <p class="customer-name">- Kumar</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Professional AC repair service. My air conditioner is cooling perfectly now."</p>
          <p class="customer-name">- Saravanan</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Quick and efficient repair service for our AC. Highly recommend!"</p>
          <p class="customer-name">- Augustin</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"The technician was very knowledgeable. My AC works like new now!"</p>
          <p class="customer-name">- Ramu</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Great service! My AC has been running smoothly since the repair."</p>
          <p class="customer-name">- Murugan</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Reliable and affordable AC repair. Very satisfied with the service!"</p>
          <p class="customer-name">- Ganesh</p>
      </div>
  </div>
</section>







      <section id="features" className="container my-5">
        <div className="row text-center">
          <div className="col-md-6 mb-4">
            <div className="feature-box d-flex align-items-center">
              <FontAwesomeIcon icon={faMoneyBillWave} className="icon-rosy-red" />
              <div className="feature-text ms-3">
                <h4>No Initial Payment</h4>
                <p>Enjoy peace of mind with our service-first policy. Pay only once the job is done to your satisfaction—no upfront costs!</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="feature-box d-flex align-items-center">
              <FontAwesomeIcon icon={faWrench} className="icon-rosy-red" />
              <div className="feature-text ms-3">
                <h4>Original Spare Parts</h4>
                <p>We use only genuine spare parts for repairs, ensuring high performance and durability for your appliances.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="feature-box d-flex align-items-center">
              <FontAwesomeIcon icon={faTachometerAlt} className="icon-rosy-red" />
              <div className="feature-text ms-3">
                <h4>Speed Service</h4>
                <p>Our team is dedicated to fast, efficient service to minimize your appliance downtime and get you back on track.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="feature-box d-flex align-items-center">
              <FontAwesomeIcon icon={faHome} className="icon-rosy-red" />
              <div className="feature-text ms-3">
                <h4>Doorstep Service</h4>
                <p>Experience the convenience of professional appliance repair at your doorstep, saving you time and effort.</p>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section class="opening-hours">
  <h2 class="section-title" id="Openhead">Opening Hours</h2>
  <div class="hours-container">
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Monday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Tuesday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Wednesday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Thursday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Friday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Saturday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day closed">
          <i class="day-icon fas fa-calendar-times"></i>
          <span>Sunday</span>
          <span>Closed</span>
      </div>
  </div>
</section>


<section id="support-services" class="support-services-section">
    <h2 class="heading-title">Customer Support</h2>
    <div class="service-container">
        <div class="service-row">
            
            <div class="col-md-4 col-sm-12">
                <div class="support-card tele-calling-card">
                    <div class="support-icon">
                        <i class="fas fa-phone-alt"></i>
                    </div>
                    <h4 class="support-card-title">Tele-calling Team</h4>
                    <p class="support-card-description">
                        Our dedicated tele-calling team is always ready to assist you with inquiries, ensuring quick responses and personalized support.
                    </p>
                </div>
            </div>
            
            <div class="col-md-4 col-sm-12">
                <div class="support-card customer-support-card">
                    <div class="support-icon">
                        <i class="fas fa-headset"></i>
                    </div>
                    <h4 class="support-card-title">24X7 Customer Support</h4>
                    <p class="support-card-description">
                        Our customer support is available 24/7, ready to help you with any issues or questions you may have at any time of day or night.
                    </p>
                </div>
            </div>
            
            <div class="col-md-4 col-sm-12">
                <div class="support-card technician-card">
                    <div class="support-icon">
                        <i class="fas fa-tools"></i>
                    </div>
                    <h4 class="support-card-title">Technician Arranging Incharge Team</h4>
                    <p class="support-card-description">
                        Our expert technician arranging incharge team ensures that the right professionals are dispatched to your location quickly and efficiently.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="faq-ac-section" class="faq-ac-section">
    <div class="container">
        <h2 class="section-title">FAQ for AC Service</h2>

        <div class="faq-card">
            <h4 class="faq-question">Why is my AC not cooling properly?</h4>
            <p class="faq-answer">
                Poor cooling can be caused by dirty filters, low refrigerant levels, or a malfunctioning compressor. It's recommended to get a technician to inspect the unit.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">Why is my AC making strange noises?</h4>
            <p class="faq-answer">
                Strange noises may be caused by loose parts, dirty filters, or issues with the fan or compressor. Scheduling an inspection can help resolve the issue.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">How often should I clean my AC filter?</h4>
            <p class="faq-answer">
                It's recommended to clean the AC filter every 1-2 months to maintain efficiency and prevent airflow problems.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">What should I do if my AC is leaking water?</h4>
            <p class="faq-answer">
                AC water leakage can be due to clogged drainage pipes, low refrigerant, or a blocked evaporator coil. Call a technician to inspect and clean the system.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">Why is my AC emitting a bad odor?</h4>
            <p class="faq-answer">
                Bad odors can be caused by mold or bacteria growth in the AC system. Cleaning the filters and ducts can help, but it is advisable to call an expert for thorough cleaning.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">How do I improve the efficiency of my AC?</h4>
            <p class="faq-answer">
                To improve efficiency, clean the filters regularly, ensure proper insulation, and schedule annual maintenance with a technician.
            </p>
        </div>
    </div>
</section>


<section id="disclaimer" class="disclaimer-section">
    <div class="disclaimer-content">
        <h2 class="disclaimer-title">Disclaimer</h2>
        <p class="disclaimer-text">
            Sri Hari Home Care is not authorized by any specific brand. We are a multibrand service provider offering assistance for a variety of home appliances.
        </p>
    </div>
</section>

    </div>
    <div><Footer /></div>
  </div>
  )
}
